import { Component, inject, ViewChild } from '@angular/core';
import { LanguageService, __i18n } from '@localisation';
import { custom } from 'devextreme/ui/dialog';
import DataSource from 'devextreme/data/data_source';

import { DxAspNetDataXsrfAwareService } from '@tools';
import { Config } from '@config';
import { UrlEnhancerService } from '@url';
import { TenantService } from '@tenant';
import { BatchUpgradeStatusService } from './batch-upgrade-status.service';
import { RoutingInfoService } from '@routing';
import { BatchUpgradeService } from './batch-upgrade.service';
import { PlantListComponent } from 'modules/plants-module/operating/plant-list.component';
import { MessagesService, MessageType } from '@ui-messages';
import { Router } from '@angular/router';

@Component({
    selector: 'batch-upgrade-details',
    templateUrl: './batch-upgrade-details.template.html',
    standalone: false
})
export class BatchUpgradeDetailsComponent {

    constructor(
        private dxAspNetXsrfAwareService: DxAspNetDataXsrfAwareService,
        private urlEnhancer: UrlEnhancerService,
        private config: Config,
        private tenantService: TenantService,
        private languageService: LanguageService,
        public batchUpgradeStatusService: BatchUpgradeStatusService,
        public batchUpgradeService: BatchUpgradeService,
        private routingInfoService: RoutingInfoService,
        private messageService: MessagesService,
        private router: Router
    ){}


    @ViewChild(PlantListComponent)
    public plantList: PlantListComponent;

    public testId: string = 'batch-upgrade-detail.list';

    public id: string = 'batch-upgrade-detail-list';

    public source: DataSource

    public batchUpgradeId: string;

    public data: any;

    public showCreateNewButton: boolean = false;

    public disableCancelButton: boolean = true;

    public async ngOnInit() {
        const routingParams = this.routingInfoService.getCurrentRoutingParams();
        this.batchUpgradeId = routingParams.batchupgradeid;
        this.source = this.setDataSource(this.batchUpgradeId);
        this.data = await this.batchUpgradeService.getBatchUprade(this.batchUpgradeId);
        if(this.data.scheduledSites + this.data.runningSites > 0){
            this.disableCancelButton = false;
        }
    }

    public setDataSource(batchUpgradeId: string) {
        const tenantId = this.tenantService.getCurrentTenantId();
        const locale = this.languageService.language;
        const url = this.urlEnhancer.replaceParams(this.config.services.upgrade.batchUpgradePlantList, {tenantId, batchUpgradeId});
        return new DataSource({
            store: this.dxAspNetXsrfAwareService.createStore({
                loadUrl: url,
                loadMethod: 'POST',
                key: 'SiteId',
                onBeforeSend: (op, settings) => {
                    settings.data.tenantId = tenantId;
                    settings.data.locale = locale;
                    settings.data.batchUpgradeId = batchUpgradeId;
                    settings.data.isAdministrationPage = true;
                }
            })
        })
    }


    private statusInterval: any;
    public async ngAfterViewInit(){
        this.statusInterval = setInterval(() => {
            this.plantList.grid.dxDataGrid.instance.refresh();
        }, 3000);

        this.showCreateNewButton = await this.batchUpgradeService.getUnsuccessfulPlantsByBatchUpgradeId(this.batchUpgradeId, this.tenantService.getCurrentTenantId(), this.languageService.language);
    //     ///////////////////////////////
    //     const tenantId = this.tenantService.getCurrentTenantId();
    //     const url = this.urlEnhancer.replaceParams(this.config.services.upgrade.batchUpgradePlantList, {tenantId, batchUpgradeId: this.batchUpgradeId});
        
    // //     key: string;
    // // take?: number;
    // // page?: number;
    // // dataFilter? : DataFilter;
    // // locale?: string;
    // // tenantId?: string;
    // // data? : {
    // //     [key: string] : string | boolean | number;
    
    //     const options = {
            
    //         key: 'SiteId',
    //         data: {
    //             locale: this.languageService.language,
    //             tenantId: tenantId,
    //             batchUpgradeId: this.batchUpgradeId
    //         }
    //     };
    //     const data = await this.#devExtremeAdaper.remoteDataSource(url, options);
    //     this.showCreateNewButton = data.data.some(current => current.batchUpgradeStatus !== "Succeeded");
    //     console.log(data);
    }

    public ngOnDestroy(){
        clearInterval(this.statusInterval)
    }

    public remoteOperations: any = {
        paging: true,
        filtering: true,
        sorting: true,
        grouping: true,
        summary: true,
        groupPaging: true
    };

    public name: string = '';

    public async confirmUpgradeAction(title, message) {
        return new Promise(async(resolve, reject) => {
            const dialog = custom({
                title,
                message,
                buttons: [
                    {
                        text: __i18n('Yes', 'batch-upgrade.details.confirm.cancel.yes.button'),
                        onClick: () => {
                            dialog.hide();
                            resolve(true);
                        }
                    },
                    {
                        text: __i18n('No', 'batch-upgrade.details.confirm.cancel.no.button'),
                        accessKey: 'esc',
                        onClick: () => {
                            dialog.hide();
                            resolve(false);
                        }
                    }
                ]
            });

            try {
                await dialog.show();
            }catch(e) {
                dialog.hide();
                resolve(false);
            }
        });
    }

    public async cancelUpgrade(){
        if(await this.confirmUpgradeAction(
            __i18n('Cancel Upgrade?', 'batch-upgrade.details.confirm.cancel.title'),
            __i18n('Are you really want to cancel the upgrade?', 'batch-upgrade.details.confirm.cancel.message')
        )) {
            await this.batchUpgradeService.cancelBatchUpgrade(this.batchUpgradeId);
            this.disableCancelButton = true;
            this.messageService.addMessage({
                text: __i18n('upgrade successfully cancelled', 'batch-upgrade.detail.success.message.cancelled'),
                type: MessageType.success,
            })
            this.plantList.grid.dxDataGrid.instance.refresh();
            this.ngOnInit();
        }
    }


    public async deleteUpgrade() {
        if(await this.confirmUpgradeAction(
            __i18n('Delete Upgrade?', 'batch-upgrade.details.confirm.delete.title'),
            __i18n('Are you really want to delete the upgrade?', 'batch-upgrade.details.confirm.delete.message')
        )) {
            await this.batchUpgradeService.deleteBatchUpgrade(this.batchUpgradeId);
            const url = '/Administration/Upgrade';
            this.messageService.addMessage({
                text: __i18n('upgrade successfully deleted', 'batch-upgrade.detail.success.message.deleted'),
                type: MessageType.success,
                location: url
            })

            this.router.navigateByUrl(url);
        }
    }
}